// extracted by mini-css-extract-plugin
export default {"root":"supplier_manager_page_root__9zIlW"};